import React, { useState } from "react";
import { sendRegisterFormEmail } from "../api/email";
import { toast } from "react-toastify";

export default function Register() {
  const [formValidation, setFormValidation] = useState({
    name: null,
    email: null,
    contact_number: null,
    job_title: null,
    cv_file: null,
  });
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contact_number: "",
    job_title: "",
  });
  const [CVFile, setCVFile] = useState(null);
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (formValidation[name] !== null) {
      validateField(name, value);
    }
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleCVFileChange = (e) => {
    const file = e.target.files[0];
    console.log(file, file.size);

    if (file.size > 10000000) {
      setFormValidation((prevValidation) => ({
        ...prevValidation,
        cv_file: false,
      }));
    }
  };

  const validateField = (field, value) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (
      field === "name" ||
      field === "contact_number" ||
      field === "job_title"
    ) {
      if (value === "") {
        setFormValidation((prevValidation) => ({
          ...prevValidation,
          [field]: false,
        }));
        return false;
      } else {
        setFormValidation((prevValidation) => ({
          ...prevValidation,
          [field]: true,
        }));
        return true;
      }
    } else if (field === "email") {
      if (emailRegex.test(value)) {
        setFormValidation((prevValidation) => ({
          ...prevValidation,
          [field]: true,
        }));
        return true;
      } else {
        setFormValidation((prevValidation) => ({
          ...prevValidation,
          [field]: false,
        }));
        return false;
      }
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const isNameValid = validateField("name", formData.name);
      const isEmailValid = validateField("email", formData.email);
      const isContactNumberValid = validateField(
        "contact_number",
        formData.contact_number,
      );
      const isJobTitleValid = validateField("job_title", formData.job_title);
      const isCVFileValid = CVFile && CVFile.size < 10000;
      if (
        isNameValid &&
        isEmailValid &&
        isContactNumberValid &&
        isJobTitleValid &&
        isCVFileValid
      ) {
        const registerFormData = new FormData();
        registerFormData.append("name", formData.name);
        registerFormData.append("email", formData.email);
        registerFormData.append("contact_number", formData.contact_number);
        registerFormData.append("job_title", formData.job_title);
        registerFormData.append("cv_file", CVFile);

        await sendRegisterFormEmail(formData);
        toast.success("Thank you! Your message has been sent.");
        setFormData({
          name: "",
          email: "",
          contact_number: "",
          job_title: "",
        });
        setFormValidation({
          name: null,
          email: null,
          contact_number: null,
          job_title: null,
          cv: null,
        });
        setCVFile(null);
      }
    } catch {
      toast.error("Server Error. Please try again.");
    }
  };
  return (
    <div className="flex flex-1 items-center justify-center">
      <section className="flex flex-col items-center justify-center p-6 lg:w-2/3 xl:w-1/2">
        <h2 className="mb-1.5 text-lg font-bold text-primaryColor md:mb-2 md:text-2xl lg:mb-3 lg:text-4xl">
          Register With Us
        </h2>
        <h3 className="mb-1.5 text-center text-sm md:mb-2 md:text-lg lg:mb-3 lg:text-xl">
          Are you an offshore professional looking for new opportunities in the
          oil, gas, and renewable energy sectors?
        </h3>
        <h3 className="mb-2.5 text-center text-sm md:mb-4 md:text-lg lg:mb-5 lg:text-xl">
          Submit your CV and join our network of skilled experts today!
        </h3>

        <form
          className="flex w-full flex-col items-center gap-3 md:gap-3.5"
          noValidate
          onSubmit={handleSubmit}
        >
          <div className="relative w-full">
            <input
              type="text"
              id="name"
              className={`peer appearance-none border-2 shadow ${formValidation.name ? "border-green-500" : formValidation.name === false ? "border-red-500" : "focus:ring"} h-10 w-full rounded-3xl px-3 py-2 text-sm leading-tight text-gray-700 placeholder:text-transparent focus:outline-none md:h-14 md:text-base lg:h-16 lg:text-lg`}
              name="name"
              value={formData.name || ""}
              onChange={handleChange}
              onBlur={() => validateField("name", formData.name)}
              required
              placeholder="Name"
            />
            <label
              htmlFor="name"
              className="absolute left-0 top-2 ml-2 -translate-y-5 bg-white px-1 text-base text-gray-500 duration-100 ease-linear peer-placeholder-shown:translate-y-0 peer-focus:-translate-y-5 peer-focus:px-1 md:top-3 md:-translate-y-7 md:text-lg md:peer-focus:-translate-y-7 lg:top-4 lg:ml-3 lg:-translate-y-8 lg:text-xl lg:peer-focus:-translate-y-8"
            >
              Name
            </label>
            <p
              className={`text-xs italic text-red-600 md:text-sm lg:mt-0.5 lg:text-base ${formValidation.name !== false && "invisible"}`}
            >
              Please provide a name.
            </p>
          </div>
          <div className="relative w-full">
            <input
              type="email"
              id="email"
              className={`peer appearance-none border-2 shadow ${formValidation.email ? "border-green-500" : formValidation.email === false ? "border-red-500" : "focus:ring"} h-10 w-full rounded-3xl px-3 py-2 text-sm leading-tight text-gray-700 placeholder:text-transparent focus:outline-none md:h-14 md:text-base lg:h-16 lg:text-lg`}
              name="email"
              value={formData.email || ""}
              onChange={handleChange}
              onBlur={() => validateField("email", formData.email)}
              required
              placeholder="Email"
            />
            <label
              htmlFor="email"
              className="absolute left-0 top-2 ml-2 -translate-y-5 bg-white px-1 text-base text-gray-500 duration-100 ease-linear peer-placeholder-shown:translate-y-0 peer-focus:-translate-y-5 peer-focus:px-1 md:top-3 md:-translate-y-7 md:text-lg md:peer-focus:-translate-y-7 lg:top-4 lg:ml-3 lg:-translate-y-8 lg:text-xl lg:peer-focus:-translate-y-8"
            >
              Email
            </label>
            <p
              className={`text-xs italic text-red-600 md:text-sm lg:mt-0.5 lg:text-base ${formValidation.email !== false && "invisible"}`}
            >
              Please provide a valid email.
            </p>
          </div>
          <div className="relative w-full">
            <input
              type="tel"
              id="contact_number"
              className={`peer appearance-none border-2 shadow ${formValidation.contact_number ? "border-green-500" : formValidation.contact_number === false ? "border-red-500" : "focus:ring"} h-10 w-full rounded-3xl px-3 py-2 text-sm leading-tight text-gray-700 placeholder:text-transparent focus:outline-none md:h-14 md:text-base lg:h-16 lg:text-lg`}
              name="contact_number"
              value={formData.contact_number || ""}
              onChange={handleChange}
              onBlur={() =>
                validateField("contact_number", formData.contact_number)
              }
              required
              placeholder="contact_number"
            />
            <label
              htmlFor="contact_number"
              className="absolute left-0 top-2 ml-2 -translate-y-5 bg-white px-1 text-base text-gray-500 duration-100 ease-linear peer-placeholder-shown:translate-y-0 peer-focus:-translate-y-5 peer-focus:px-1 md:top-3 md:-translate-y-7 md:text-lg md:peer-focus:-translate-y-7 lg:top-4 lg:ml-3 lg:-translate-y-8 lg:text-xl lg:peer-focus:-translate-y-8"
            >
              Contact Number
            </label>
            <p
              className={`text-xs italic text-red-600 md:text-sm lg:mt-0.5 lg:text-base ${formValidation.contact_number !== false && "invisible"}`}
            >
              Please provide a valid contact number.
            </p>
          </div>
          <div className="relative w-full">
            <input
              type="text"
              id="job_title"
              className={`peer appearance-none border-2 shadow ${formValidation.job_title ? "border-green-500" : formValidation.job_title === false ? "border-red-500" : "focus:ring"} h-10 w-full rounded-3xl px-3 py-2 text-sm leading-tight text-gray-700 placeholder:text-transparent focus:outline-none md:h-14 md:text-base lg:h-16 lg:text-lg`}
              name="job_title"
              value={formData.job_title || ""}
              onChange={handleChange}
              onBlur={() => validateField("job_title", formData.job_title)}
              required
              placeholder="Job Title"
            />
            <label
              htmlFor="job_title"
              className="absolute left-0 top-2 ml-2 -translate-y-5 bg-white px-1 text-base text-gray-500 duration-100 ease-linear peer-placeholder-shown:translate-y-0 peer-focus:-translate-y-5 peer-focus:px-1 md:top-3 md:-translate-y-7 md:text-lg md:peer-focus:-translate-y-7 lg:top-4 lg:ml-3 lg:-translate-y-8 lg:text-xl lg:peer-focus:-translate-y-8"
            >
              Job Title
            </label>
            <p
              className={`text-xs italic text-red-600 md:text-sm lg:mt-0.5 lg:text-base ${formValidation.job_title !== false && "invisible"}`}
            >
              Please provide a job title.
            </p>
          </div>
          <div className="flex w-full flex-col">
            <label
              htmlFor="cv_file"
              className="mb-2 text-base text-gray-500 md:mb-3 md:text-lg lg:mb-4 lg:text-xl"
            >
              Upload Your CV
            </label>
            <input
              type="file"
              id="cv_file"
              name="cv_file"
              onChange={handleCVFileChange}
              accept=".doc,.docx,.pdf"
            />
            <p
              className={`text-xs italic text-red-600 md:text-sm lg:mt-0.5 lg:text-base ${formValidation.cv_file !== false && "invisible"}`}
            >
              Please provide a valid file under 10mb.
            </p>
          </div>
          <button className="rounded-3xl bg-primaryColor px-4 py-2 text-base font-bold text-secondaryColor shadow-md transition-all hover:bg-primaryHover hover:shadow-lg focus:bg-primaryHover focus:shadow-none active:bg-primaryHover active:shadow-none md:py-3 md:text-base lg:px-5 lg:py-3 lg:text-lg xl:px-8 xl:py-4 xl:text-xl">
            Submit
          </button>
        </form>
      </section>
    </div>
  );
}
